import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import api from '../../../../../api/api';
import Loader from '../../../../_common/Loader/Loader';
import classes from './tabs.module.scss';

const Faxes = ({ count }) => {
  const { scriptId } = useParams();
  const [faxes, setFaxes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const { data: { response = [] } } = await api.getFaxes({ scriptId });

      setFaxes(response.reverse());
      setLoading(false);
    })();
  }, [count]);

  if (loading) {
    return (
      <div className={classes.status_loader}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={classes.script_rx_wrapper}>
      {!faxes.length
        ? <div className={classes.notResult}>No Data Found</div>

        : (
          <div className={classes.table_wrapper}>
            <div>
              <table style={{ maxWidth: 760 }}>
                <thead>
                  <tr>
                    <th>File</th>

                    <th>Date</th>
                  </tr>
                </thead>

                <tbody>
                  {faxes.map((fax) => (
                    <tr key={fax.id} className={classes.tr}>
                      <td>
                        <a href={fax.fileName} style={{ color: 'rgba(29, 39, 64, 0.8)', textDecoration: 'none' }} target="_blank" rel="noreferrer">
                          {fax.fileName.split('/').pop()}
                        </a>
                      </td>

                      <td>{moment.utc(fax.createdAt).local().format('MM/DD/YYYY LT')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
    </div>
  );
};

export default Faxes;
